import { createMultiStyleConfigHelpers as n, defineStyle as a } from "@chakra-ui/react";
import { ThemeSpaceVariable as e, ThemeFontSizeVariable as r, ThemeColorVariable as o, ThemeShadowVariable as t } from "../../theme-types.js";
import { menuAnatomy as l } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: i, defineMultiStyleConfig: c } = n(l.keys), d = a({
  minW: "280px",
  alignItems: "center",
  paddingLeft: e.Medium,
  paddingRight: e.Medium,
  paddingTop: e.Small,
  paddingBottom: e.Small,
  color: o.OnSurface,
  backgroundColor: o.Surface,
  cursor: "pointer",
  _hover: {
    backgroundColor: o.AccentHoverAlpha,
    textDecoration: "underline",
    _disabled: {
      textDecoration: "none",
      backgroundColor: "transparent"
    }
  },
  _focus: {
    backgroundColor: o.AccentHoverAlpha,
    textDecoration: "underline",
    _disabled: {
      textDecoration: "none",
      backgroundColor: "transparent"
    }
  },
  // Seems to be the only way to override the default margin of the icon (left)
  ".chakra-menu__icon-wrapper": {
    mr: e.XSmall
  }
}), m = a({
  boxShadow: t.Medium,
  bg: o.Surface,
  border: "none",
  borderRadius: e.Small
}), u = a({
  opacity: 1,
  color: o.OnSurfaceSubdued,
  fontSize: r.Small,
  mx: e.XSmall
}), S = i({
  item: d,
  list: m,
  command: u
}), f = c({
  baseStyle: S
});
export {
  f as menuConfig
};
